'use client'
import { Box, Button, Typography } from '@mui/material'

const DEALER_TERMS_PDF_URL =
  'https://cdn.zuto.cloud/assets/pdfs/dealer_terms_and_conditions.pdf'

const PageContent = () => {
  return (
    <Box component="section">
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: '32px', sm: '50px' },
          mb: 4,
          marginTop: { xs: 5, lg: 0 }
        }}
      >
        Zuto Legals
      </Typography>
      <Button
        variant="contained"
        size="large"
        href={DEALER_TERMS_PDF_URL}
        target="_blank"
        rel="noopener noreferrer"
        role="link"
        sx={{ minWidth: '260px', marginTop: 1 }}
      >
        View Dealership Terms (PDF)
      </Button>
    </Box>
  )
}

export default PageContent
